
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'EChartsScrollContainer',
    props: {
      minWidth: {
        type: Number,
        default: 720,
      },
    },
    computed: {
      getContentStyle(): Record<string, string> {
        return { minWidth: `${this.minWidth}px` };
      },
    },
  });
